import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

const adminDelegationService = {
  getDelegableTasks: async (user, processTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/delegation/${processTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
}

export default adminDelegationService
